import styled, { css } from 'styled-components'

const separatorWidth = '50px'

export const SimpleBridgeBuilderWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 2rem;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 0;
  }
`

export const SimpleBridgeBuilderCardSeparator = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 5.5rem;
  color: ${({ theme }) => theme.color.primary};
  width: ${separatorWidth};
  @media (max-width: 767px) {
    width: 100%;
    padding: 0.5rem 0;
  }
`

export const getBridgeBuilderTypografy = () => css`
  h1,
  h2 {
    text-align: center;
    color: #191919;
  }

  h1 {
    font-size: 1.125rem;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 1rem;
  }

  /* synch this > subtitle */
  h4 {
    margin: 0 0 1rem;
    font-weight: 400;
    font-size: 0.8rem;
    text-align: center;
  }

  label {
    font-size: 0.8rem;
  }
`

export const SimpleBridgeBuilderCard = styled.div<{ hasError?: boolean }>`
  height: 100%;
  border: 1px solid
    ${({ hasError, theme }) =>
      hasError ? theme.input.error.borderColor : '#dfe4e8'};
  border-radius: 4px;
  padding: 1rem;
  position: relative;

  @media (min-width: 768px) {
    flex: 1;
    width: calc(50% - (${separatorWidth} / 2));
  }

  ${getBridgeBuilderTypografy};

  & > div {
    margin-bottom: 0.7rem;
  }
`

export const IntegrationRequestLink = styled.button`
  display: block;
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.primary};
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0;
  margin: 1.5rem auto 0;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`
